var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 130,
    viewBox: "0 0 1440 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58.776C0 58.776 151 0.275224 289.5 0.00145925C432.678 -0.281553 596.5 41.3424 890 58.776C1183.5 76.2097 1440 25.4036 1440 25.4036V130H0V58.776Z",
    fill: "#602EF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter2);
export default __webpack_public_path__ + "static/media/footer2.e6c319056164672320e0839a5fc2dd9d.svg";
export { ForwardRef as ReactComponent };